module.exports = __webpack_public_path__ + "img/@work_bottom_m_off.6148fb3d.jpg";